import socialMedia from './_socialMedia';
import {getBaseUrl} from './utils';
import {FooterConfig, GetConfigParams} from '../shared';

const PHONE_NUMBER = '1300 664 316';
const CORPORATE_PHONE_NUMBER = null;
const ABSOLUTE_BASEURL = 'https://www.nib.com.au';

const getShareholdersConfig = (config: GetConfigParams): FooterConfig => {
  const baseUrl = getBaseUrl(config, ABSOLUTE_BASEURL);
  return {
    id: 'footer-shareholders',
    columns: [
      {
        id: 'ga-footer-shareholders-quick-links',
        title: 'Quick links',
        children: [
          {
            id: 'ga-footer-shareholders-update-your-details',
            title: 'Update your details',
            url: `${baseUrl}/shareholders/manage-your-shareholding/update-your-shareholding`
          },
          {
            id: 'ga-footer-shareholders-dividend-information',
            title: 'Dividend information',
            url: `${baseUrl}/shareholders/manage-your-shareholding/dividend-information`
          },
          {
            id: 'ga-footer-shareholders-key-events-calendar',
            title: 'Key events calendar',
            url: `${baseUrl}/shareholders/calendar`
          },
          {
            id: 'ga-footer-shareholders-share-price',
            title: 'Share price',
            url: `${baseUrl}/shareholders/financial-information/share-price`
          }
        ]
      },
      {
        id: 'ga-footer-shareholders-quick-links-2',
        title: ' ',
        children: [
          {
            id: 'ga-footer-shareholders-financial-results',
            title: 'Financial results',
            url: `${baseUrl}/shareholders/financial-results`
          },
          {
            id: 'ga-footer-shareholders-annual-reports',
            title: 'Annual reports',
            url: `${baseUrl}/shareholders/annual-reports`
          },
          {
            id: 'ga-footer-shareholders-announcements',
            title: 'Announcements',
            url: `${baseUrl}/shareholders/announcements/asx`
          },
          {
            id: 'ga-footer-shareholders-buy-and-sell-shares',
            title: 'Buy and sell shares',
            url: `${baseUrl}/shareholders/manage-your-shareholding/buying-selling-nib-shares`
          }
        ]
      },
      {
        id: 'ga-footer-shareholders-help',
        title: 'Help',
        children: [
          {
            id: 'ga-footer-shareholders-faq',
            title: 'Frequently asked questions',
            url: `${baseUrl}/shareholders/help/faqs`
          },
          {
            id: 'ga-footer-shareholders-contact-us',
            title: 'Contact us',
            url: `${baseUrl}/shareholders/contact-us`
          }
        ]
      }
    ],
    contact: {
      phoneNumber: PHONE_NUMBER,
      corporatePhoneNumber: CORPORATE_PHONE_NUMBER,
      socialLinks: socialMedia
    },
    smallFooterConfig: {
      id: 'small-footer-shareholders',
      copyrightText: `Copyright © ${new Date().getFullYear()} nib health funds limited ABN 83 000 124 381`,
      phoneNumber: PHONE_NUMBER,
      corporatePhoneNumber: CORPORATE_PHONE_NUMBER,
      links: [
        {
          id: 'ga-footer-shareholders-terms',
          title: 'Terms & Conditions',
          url: `${baseUrl}/docs/online-terms`
        },
        {
          id: 'ga-footer-shareholders-privacy',
          title: 'Privacy Policy',
          url: `${baseUrl}/legal/privacy-policy`
        },
        {
          id: 'ga-footer-shareholders-code-conduct',
          title: 'Code of Conduct',
          url: `${baseUrl}/legal#codeofconduct`
        }
      ]
    }
  };
};

export default getShareholdersConfig;
